module.exports = __webpack_public_path__ + "img/icon_3_22.38597a9c.png";